export default "/assets/website/images/2022-25.jpeg?6ec7ed35c0795b0ab4be60c4d9e31f7d";